import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@core/i18n';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
  readonly phone = '+1 (555) 123-4567';
  readonly phoneHref = 'tel:+15551234567';
  readonly email = 'stay@maisonverde.com';
  readonly emailHref = 'mailto:stay@maisonverde.com';
  readonly address = '142 Linden Avenue, Lisbon';

  readonly exploreLinks = [
    { labelKey: 'nav.home', route: '/home' },
    { labelKey: 'nav.rooms', route: '/rooms' },
    { labelKey: 'nav.about', route: '/about' },
    { labelKey: 'nav.reviews', route: '/reviews' },
    { labelKey: 'nav.contact', route: '/contact' },
  ];

  readonly informationLinks = [
    { labelKey: 'footer.privacy', route: '/privacy' },
    { labelKey: 'footer.terms', route: '/terms' },
    { labelKey: 'footer.cancellation', route: '/cancellation' },
    { labelKey: 'footer.faq', route: '/faq' },
  ];

  readonly socialLinks = [
    { platform: 'instagram' as const, labelKey: 'footer.socialInstagram', href: 'https://instagram.com' },
    { platform: 'facebook' as const, labelKey: 'footer.socialFacebook', href: 'https://facebook.com' },
    { platform: 'twitter' as const, labelKey: 'footer.socialTwitter', href: 'https://twitter.com' },
  ];
}
